var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowsOutSimple = function SvgIconArrowsOutSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5a1 1 0 1 1 0-2h4.5a1 1 0 0 1 1 1V9a1 1 0 1 1-2 0V6.914l-3.543 3.543a1 1 0 0 1-1.414-1.414L17.086 5.5zM10.457 13.543a1 1 0 0 1 0 1.414L6.914 18.5H9a1 1 0 1 1 0 2H4.5a1 1 0 0 1-1-1V15a1 1 0 1 1 2 0v2.086l3.543-3.543a1 1 0 0 1 1.414 0"
  }))));
};
export default SvgIconArrowsOutSimple;